import DepositAmountForm from './DepositAmountForm';
export default DepositAmountForm;
